(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var dialog = document.querySelector('[data-cart-modal]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var lineSlot = dialog.querySelector('[data-cart-line]');
    var upsellSlot = dialog.querySelector('[data-cart-upsell-slot]');
    var errorEl = dialog.querySelector('[data-cart-error]');
    var titleEl = dialog.querySelector('#cart-modal-title');
    var eyebrow = dialog.querySelector('[data-cart-eyebrow]');
    var lastFocus = null;

    var L = {
      addedTitle: dialog.getAttribute('data-l-added-title'),
      setsTitle: dialog.getAttribute('data-l-sets-title'),
      upgrade: dialog.getAttribute('data-l-upgrade'),
      addons: dialog.getAttribute('data-l-addons'),
      add: dialog.getAttribute('data-l-add'),
      added: dialog.getAttribute('data-l-added'),
      error: dialog.getAttribute('data-l-error'),
      upgradedTitle: dialog.getAttribute('data-l-upgraded-title'),
      upgradedNote: dialog.getAttribute('data-l-upgraded-note'),
      tplQty: dialog.getAttribute('data-tpl-qty') || '',
      tplSurcharge: dialog.getAttribute('data-tpl-surcharge') || '',
      tplSavings: dialog.getAttribute('data-tpl-savings') || ''
    };

    function fill(tpl, token, val) { return tpl.split(token).join(val); }
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    function withWidth(url, w) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

    function setCartCount(total) {
      var nodes = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].textContent = total;
        nodes[i].classList.toggle('is-empty', !(total > 0));
      }
    }
    // Optimistic count bump — avoids a redundant GET /cart.js on the add path. add.js
    // returns the line's NEW total (not the delta), so we bump by the quantity we
    // requested, which is the actual amount added on success.
    function bumpCartCount(delta) {
      if (!delta) return;
      var nodes = document.querySelectorAll('[data-cart-count]');
      for (var i = 0; i < nodes.length; i++) {
        var n = parseInt(nodes[i].textContent, 10) || 0;
        var next = Math.max(0, n + delta);
        nodes[i].textContent = next;
        nodes[i].classList.toggle('is-empty', !(next > 0));
      }
    }

    function getUpsellData(productId) {
      var blocks = document.querySelectorAll('[data-cart-upsell]');
      var chosen = null, i;
      for (i = 0; i < blocks.length; i++) {
        if (blocks[i].getAttribute('data-product-id') === String(productId)) { chosen = blocks[i]; break; }
      }
      if (!chosen && blocks.length) chosen = blocks[0];
      if (!chosen) return null;
      try { return JSON.parse(chosen.textContent); } catch (e) { return null; }
    }

    function normalizeAdded(json) {
      if (json && json.items) return json.items;
      if (json && json.id) return [json];
      return [];
    }

    function renderLine(items) {
      var html = '';
      items.forEach(function (it) {
        var img = it.image || (it.featured_image && it.featured_image.url) || '';
        html += '<div class="cart-modal__item">' +
          (img ? '<img class="cart-modal__thumb" src="' + withWidth(img, 120) + '" alt="" width="60" height="60" loading="lazy">' : '') +
          '<div class="cart-modal__item-body">' +
            '<span class="cart-modal__item-name">' + esc(it.product_title || it.title) + '</span>' +
            '<span class="cart-modal__item-qty">' + fill(L.tplQty, '%count%', it.quantity) + '</span>' +
          '</div>' +
        '</div>';
      });
      lineSlot.innerHTML = html;
    }

    // Complementary add-ons come from the product-complementary section, whose
    // resolved list includes the manual fallback that the metafield-only upsell
    // data misses. Fall back to the upsell-data block if that section is absent.
    function getComplementary(data) {
      var el = document.querySelector('[data-cart-complementary]');
      if (el) {
        try { var arr = JSON.parse(el.textContent); if (arr && arr.length) return arr; } catch (e) {}
      }
      return (data && data.complementary) || [];
    }

    function renderUpsell(data, added) {
      upsellSlot.innerHTML = '';
      upsellSlot.hidden = true;
      if (!data) return;

      var addedProductIds = added.map(function (i) { return i.product_id; });
      var showSets = data.sets && data.sets.length && addedProductIds.indexOf(data.productId) > -1;
      var html = '';

      // Show both upsell sections when available: set upgrades first, then add-ons.
      if (showSets) {
        var knife = added.filter(function (i) { return i.product_id === data.productId; })[0] || added[0];
        html += '<p class="cart-modal__upsell-title">' + esc(L.setsTitle) + '</p><ul class="cart-modal__sets">';
        data.sets.forEach(function (s) {
          if (s.available === false) return;
          var cta = s.surchargeMoney ? fill(L.tplSurcharge, '%amount%', esc(s.surchargeMoney)) : esc(L.upgrade);
          html += '<li class="cart-modal__set">' +
            '<a class="cart-modal__set-link" href="' + s.url + '">' +
              (s.image ? '<img class="cart-modal__set-img" src="' + withWidth(s.image, 120) + '" alt="" width="56" height="56" loading="lazy">' : '') +
              '<span class="cart-modal__set-info">' +
                '<span class="cart-modal__set-name">' + esc(s.title) + '</span>' +
                '<span class="cart-modal__set-meta">' + esc(s.setPriceMoney) +
                  (s.savings ? ' · <span class="cart-modal__set-save">' + fill(L.tplSavings, '%amount%', esc(s.savings)) + '</span>' : '') +
                '</span>' +
              '</span>' +
            '</a>' +
            '<button type="button" class="cart-modal__upgrade" data-upgrade ' +
              'data-set-variant="' + s.variantId + '" data-knife-variant="' + knife.variant_id + '" data-knife-qty="' + knife.quantity + '">' +
              cta +
            '</button>' +
          '</li>';
        });
        html += '</ul>';
      }

      var comp = getComplementary(data);
      if (comp.length) {
        html += '<p class="cart-modal__upsell-title">' + esc(L.addons) + '</p><ul class="cart-modal__addons">';
        comp.forEach(function (c) {
          if (c.available === false) return;
          html += '<li class="cart-modal__addon">' +
            '<a class="cart-modal__addon-link" href="' + c.url + '">' +
              (c.image ? '<img class="cart-modal__addon-img" src="' + withWidth(c.image, 96) + '" alt="" width="44" height="44" loading="lazy">' : '') +
              '<span class="cart-modal__addon-name">' + esc(c.title) + '</span>' +
            '</a>' +
            '<span class="cart-modal__addon-price">' + esc(c.priceMoney) + '</span>' +
            '<button type="button" class="cart-modal__add" data-quick-add data-variant="' + c.variantId + '">' + esc(L.add) + '</button>' +
          '</li>';
        });
        html += '</ul>';
      }

      if (html) {
        upsellSlot.innerHTML = html;
        upsellSlot.hidden = false;
      }
    }

    function showError(msg) {
      errorEl.textContent = msg || L.error;
      errorEl.hidden = false;
    }

    function open() {
      if (!dialog.open) {
        lastFocus = document.activeElement;
        dialog.showModal();
      }
    }
    function close() { if (dialog.open) dialog.close(); }

    function doAdd(payload) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) {
        return r.json().then(function (json) { if (!r.ok) throw json; return json; });
      });
    }

    function addAndShow(payload) {
      errorEl.hidden = true;
      // The quantity we requested = the amount actually added on success (add.js reports
      // the line's new total, not the delta, so the count must come from the request).
      var requestedQty = payload.items
        ? payload.items.reduce(function (s, it) { return s + (parseInt(it.quantity, 10) || 0); }, 0)
        : (parseInt(payload.quantity, 10) || 0);
      doAdd(payload).then(function (json) {
        var added = normalizeAdded(json);
        eyebrow.hidden = false;
        titleEl.textContent = L.addedTitle;
        renderLine(added);
        renderUpsell(getUpsellData(added.length ? added[0].product_id : null), added);
        bumpCartCount(requestedQty);
        open();
      }).catch(function (err) {
        eyebrow.hidden = true;
        lineSlot.innerHTML = '';
        upsellSlot.hidden = true;
        upsellSlot.innerHTML = '';
        showError(err && err.description ? err.description : null);
        open();
      });
    }

    function doUpgrade(btn) {
      var setVariant = parseInt(btn.getAttribute('data-set-variant'), 10);
      var knifeVariant = parseInt(btn.getAttribute('data-knife-variant'), 10);
      var knifeAddedQty = parseInt(btn.getAttribute('data-knife-qty'), 10) || 1;
      btn.disabled = true;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var knifeQty = 0, setQty = 0;
          cart.items.forEach(function (it) {
            if (it.variant_id === knifeVariant) knifeQty = it.quantity;
            if (it.variant_id === setVariant) setQty = it.quantity;
          });
          var updates = {};
          updates[knifeVariant] = Math.max(0, knifeQty - knifeAddedQty);
          updates[setVariant] = setQty + 1;
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });
        })
        .then(function (r) { if (!r.ok) throw new Error('update'); return r.json(); })
        .then(function (cart) {
          titleEl.textContent = L.upgradedTitle;
          lineSlot.innerHTML = '<p class="cart-modal__upgraded-note">' + esc(L.upgradedNote) + '</p>';
          upsellSlot.hidden = true;
          upsellSlot.innerHTML = '';
          // update.js returns the full cart, so use its authoritative item_count (no extra GET).
          if (cart && typeof cart.item_count === 'number') setCartCount(cart.item_count);
        })
        .catch(function () { btn.disabled = false; showError(); });
    }

    function doQuickAdd(btn) {
      var variant = parseInt(btn.getAttribute('data-variant'), 10);
      btn.disabled = true;
      doAdd({ id: variant, quantity: 1 })
        .then(function () { btn.textContent = L.added; btn.classList.add('is-added'); bumpCartCount(1); })
        .catch(function () { btn.disabled = false; showError(); });
    }

    // Intercept product-form submits document-wide. Runs in the bubble phase, after
    // the section's own submit handler — so if that handler already prevented default
    // (bundle redirect / unavailable variant) we leave it alone.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.classList || !form.classList.contains('product-form')) return;
      if (e.defaultPrevented) return;
      e.preventDefault();
      var fd = new FormData(form);
      var id = fd.get('id');
      if (!id) return;
      addAndShow({ id: id, quantity: parseInt(fd.get('quantity'), 10) || 1 });
    });

    // Programmatic adds (e.g. complementary "add selected").
    document.addEventListener('cart:add', function (e) {
      var d = e.detail || {};
      if (d.items) addAndShow({ items: d.items });
      else if (d.id) addAndShow({ id: d.id, quantity: d.quantity || 1 });
    });

    dialog.addEventListener('click', function (e) {
      if (e.target === dialog) { close(); return; }
      if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-continue]')) { close(); return; }
      var up = e.target.closest('[data-upgrade]');
      if (up) { e.preventDefault(); doUpgrade(up); return; }
      var qa = e.target.closest('[data-quick-add]');
      if (qa) { e.preventDefault(); doQuickAdd(qa); return; }
    });

    dialog.addEventListener('close', function () {
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["media-zoom"] && !Shopify.designMode) return;
  try {
    (function () {
    const hero = document.querySelector('.pdp [data-main-media]');
    if (!hero) return;
    const heroImg = hero.querySelector('img');
    if (!heroImg) return;

    const fine = window.matchMedia('(hover: hover) and (pointer: fine)');

    function videoPlaying() {
      return !!document.querySelector('.pdp [data-video-frame].is-on');
    }

    function zoomable() {
      return fine.matches && !hero.classList.contains('is-video-media') && !videoPlaying();
    }

    // Hero je LCP prvek s fetchpriority=high, takže 2400px zdroj tahá až první
    // hover — nikdy ne při načtení stránky. Gate na tom, co <img> aktuálně
    // zobrazuje (ne na cache proměnné) — self-healing při resetu src i při
    // neúspěšném načtení.
    function loadHires() {
      const url = hero.dataset.zoom;
      if (!url) return;
      if (heroImg.getAttribute('src') === url) return;
      const pre = new Image();
      pre.src = url;
      const swap = function () {
        if (hero.dataset.zoom !== url) return; // mezitím se přepnulo médium
        heroImg.removeAttribute('srcset');
        heroImg.removeAttribute('sizes');
        heroImg.src = url;
      };
      if (pre.decode) pre.decode().then(swap).catch(function () {});
      else pre.addEventListener('load', swap);
    }

    // getBoundingClientRect forces layout. Reading it on every pointermove meant a forced
    // reflow per mouse event while zooming; the box only changes on scroll or resize, so
    // cache it and invalidate on those.
    let heroRect = null;
    function invalidateHeroRect() { heroRect = null; }
    window.addEventListener('scroll', invalidateHeroRect, { passive: true });
    window.addEventListener('resize', invalidateHeroRect, { passive: true });

    function track(event) {
      if (!heroRect) heroRect = hero.getBoundingClientRect();
      const x = ((event.clientX - heroRect.left) / heroRect.width) * 100;
      const y = ((event.clientY - heroRect.top) / heroRect.height) * 100;
      heroImg.style.transformOrigin = x + '% ' + y + '%';
    }

    hero.addEventListener('pointerenter', function (event) {
      if (event.pointerType === 'touch' || !zoomable()) return;
      loadHires();
      track(event);
      hero.classList.add('is-zooming');
    });

    hero.addEventListener('pointermove', function (event) {
      if (!hero.classList.contains('is-zooming')) return;
      if (!zoomable()) { hero.classList.remove('is-zooming'); return; }
      track(event);
    });

    // transform-origin se schválně neresetuje — reset by fotku při odjezdu
    // kurzoru nejdřív škubl doprostřed a teprve pak zmenšil.
    hero.addEventListener('pointerleave', function () {
      hero.classList.remove('is-zooming');
      invalidateHeroRect();
    });

    const box = document.querySelector('[data-mediabox]');
    const dataEl = document.querySelector('[data-zoom-media]');
    if (!box || !dataEl || typeof box.showModal !== 'function') {
      // Bez podpory <dialog> zůstává hover zoom, ale klik nemá co otevřít.
      hero.style.cursor = 'default';
      return;
    }

    let items = [];
    try {
      items = JSON.parse(dataEl.textContent || '[]');
    } catch (err) {
      items = [];
    }
    if (!items.length) {
      hero.style.cursor = 'default';
      return;
    }

    const stage = box.querySelector('[data-mediabox-stage]');
    const boxImg = box.querySelector('[data-mediabox-img]');
    const counter = box.querySelector('[data-mediabox-counter]');
    const prevBtn = box.querySelector('[data-mediabox-prev]');
    const nextBtn = box.querySelector('[data-mediabox-next]');
    const tplCounter = box.dataset.tplCounter || '%index% / %total%';

    let index = 0;
    let lastFocus = null;

    function updateCounter() {
      counter.textContent = tplCounter.replace('%index%', index + 1).replace('%total%', items.length);
    }

    const MAX_SCALE = 4;
    const TAP_SCALE = 2.5;
    let scale = 1;
    let tx = 0;
    let ty = 0;
    let hiresPending = '';
    let lastTapAt = 0;

    function renderBox() {
      scale = 1; tx = 0; ty = 0;
      boxImg.style.transition = 'none';
      boxImg.style.transform = '';
      boxImg.style.cursor = 'zoom-in';
      lastTapAt = 0;
      hiresPending = '';
      const item = items[index];
      if (!item) return;
      boxImg.src = item.preview;
      boxImg.alt = item.alt || '';
      updateCounter();
      const multi = items.length > 1;
      prevBtn.hidden = !multi;
      nextBtn.hidden = !multi;
      counter.hidden = !multi;
    }

    function go(delta) {
      if (items.length < 2) return;
      index = (index + delta + items.length) % items.length;
      renderBox();
    }

    function openBox() {
      if (hero.classList.contains('is-video-media')) return;
      const id = hero.dataset.mediaId;
      const found = items.findIndex(function (m) { return String(m.id) === String(id); });
      index = found > -1 ? found : 0;
      lastFocus = document.activeElement;
      lastPointerType = '';
      renderBox();
      box.showModal();
      // Dialog je do showModal() display:none, takže zápis do aria-live oblasti
      // proběhne mimo strom přístupnosti. Přepíšeme ho, až je dialog vidět.
      counter.textContent = '';
      requestAnimationFrame(function () { requestAnimationFrame(updateCounter); });
      maybeHint();
    }

    let closedAt = -Infinity;
    let lastPointerType = '';

    function closeBox() {
      // Razítko musí padnout synchronně — `close` event dorazí až o pár
      // milisekund později a doklik po tapu by ho předběhl. Myš ani klávesnici
      // neblokujeme, doklik po nich se retargetuje jinak.
      closedAt = lastPointerType === 'touch' ? performance.now() : -Infinity;
      box.close();
    }

    // Zavření tapem pošle doklikovou událost znovu hit-testovanou na stránku pod
    // dialogem — na mobilu trefí hero tlačítko a prohlížeč by se otevřel zpátky.
    hero.addEventListener('click', function () {
      if (performance.now() - closedAt < 400) return;
      openBox();
    });
    box.querySelector('[data-mediabox-close]').addEventListener('click', closeBox);
    prevBtn.addEventListener('click', function () { go(-1); });
    nextBtn.addEventListener('click', function () { go(1); });

    // Klik na plochu dialogu mimo fotku zavírá.
    box.addEventListener('click', function (event) {
      if (suppressClick) { suppressClick = false; return; }
      if (event.target === box || event.target === stage) closeBox();
    });

    box.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') { event.preventDefault(); go(-1); }
      else if (event.key === 'ArrowRight') { event.preventDefault(); go(1); }
    });

    // ESC i tlačítko zavírají přes nativní `close` event — úklid je na jednom místě.
    box.addEventListener('close', function () {
      resetTransform();
      pointers.clear();
      multiTouch = false;
      suppressClick = false;
      clearTimeout(hintTimer);
      if (hintEl) hintEl.hidden = true;
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    });

    function applyTransform(animate) {
      boxImg.style.transition = animate ? 'transform 220ms ease' : 'none';
      boxImg.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + scale + ')';
      boxImg.style.cursor = scale > 1 ? 'grab' : 'zoom-in';
    }

    function resetTransform() {
      scale = 1; tx = 0; ty = 0;
      applyTransform(false);
    }

    // Element vyplňuje stage, fotka je v něm letterboxovaná přes object-fit: contain.
    // Meze posunu se počítají z vykreslené fotky, ne z elementu.
    function clampPan() {
      const cw = boxImg.offsetWidth;
      const ch = boxImg.offsetHeight;
      const nw = boxImg.naturalWidth;
      const nh = boxImg.naturalHeight;
      let rw = cw;
      let rh = ch;
      if (nw && nh) {
        const fit = Math.min(cw / nw, ch / nh);
        rw = nw * fit;
        rh = nh * fit;
      }
      const maxX = Math.max(0, (rw * scale - cw) / 2);
      const maxY = Math.max(0, (rh * scale - ch) / 2);
      tx = Math.min(maxX, Math.max(-maxX, tx));
      ty = Math.min(maxY, Math.max(-maxY, ty));
    }

    // Fotka je v elementu letterboxovaná, takže "klepnul na fotku" nejde poznat
    // z event.target — pruhy vedle fotky patří pořád <img>. Počítá se z vykresleného
    // obdélníku, včetně aktuálního přiblížení.
    function onPhoto(clientX, clientY) {
      const nw = boxImg.naturalWidth;
      const nh = boxImg.naturalHeight;
      if (!nw || !nh) return true;
      const cw = boxImg.offsetWidth;
      const ch = boxImg.offsetHeight;
      const fit = Math.min(cw / nw, ch / nh);
      const r = boxImg.getBoundingClientRect();
      const cx = r.left + r.width / 2;
      const cy = r.top + r.height / 2;
      return Math.abs(clientX - cx) <= (nw * fit * scale) / 2
        && Math.abs(clientY - cy) <= (nh * fit * scale) / 2;
    }

    // Přiblíží tak, aby bod pod prstem/kurzorem zůstal na místě.
    function zoomAt(next, clientX, clientY, animate) {
      const target = Math.min(MAX_SCALE, Math.max(1, next));
      const s = stage.getBoundingClientRect();
      const ox = clientX - s.left - s.width / 2;
      const oy = clientY - s.top - s.height / 2;
      const k = target / scale;
      tx = ox - (ox - tx) * k;
      ty = oy - (oy - ty) * k;
      scale = target;
      if (scale === 1) { tx = 0; ty = 0; }
      clampPan();
      applyTransform(animate);
      if (scale > 1) loadBoxHires();
    }

    // Baymard: vyšší rozlišení dotáhnout až ve chvíli, kdy uživatel zoomuje —
    // kdo si jen prolistuje fotky, nestahuje 2400px snímky.
    function loadBoxHires() {
      const item = items[index];
      if (!item || !item.zoom) return;
      if (boxImg.getAttribute('src') === item.zoom) return;
      if (hiresPending === item.zoom) return;
      // Drží i po neúspěchu, aby se zoom nezacyklil na padající adrese;
      // renderBox() ho při přepnutí fotky čistí, takže návrat zkusí znovu.
      hiresPending = item.zoom;
      const at = index;
      const pre = new Image();
      pre.src = item.zoom;
      const swap = function () {
        if (index !== at) return; // mezitím se přepnula fotka
        boxImg.src = item.zoom;
      };
      if (pre.decode) pre.decode().then(swap).catch(function () {});
      else pre.addEventListener('load', swap);
    }

    const pointers = new Map();
    let pinchStartDist = 0;
    let pinchStartScale = 1;
    let panFrom = null;
    let gestureStart = null;
    let suppressClick = false;
    let downOnPhoto = false;
    let multiTouch = false;

    function pointerList() {
      return Array.from(pointers.values());
    }

    function distance(a, b) {
      return Math.hypot(a.x - b.x, a.y - b.y);
    }

    stage.addEventListener('pointerdown', function (event) {
      suppressClick = false;
      lastPointerType = event.pointerType;
      stage.setPointerCapture(event.pointerId);
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
      if (pointers.size === 1) {
        downOnPhoto = onPhoto(event.clientX, event.clientY);
        gestureStart = { x: event.clientX, y: event.clientY };
        panFrom = { x: event.clientX, y: event.clientY, tx: tx, ty: ty };
      } else if (pointers.size === 2) {
        multiTouch = true;
        const p = pointerList();
        pinchStartDist = distance(p[0], p[1]);
        pinchStartScale = scale;
      }
    });

    stage.addEventListener('pointermove', function (event) {
      if (!pointers.has(event.pointerId)) return;
      pointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

      if (pointers.size >= 2) {
        const p = pointerList();
        const d = distance(p[0], p[1]);
        if (!pinchStartDist) return;
        const mid = { x: (p[0].x + p[1].x) / 2, y: (p[0].y + p[1].y) / 2 };
        zoomAt(pinchStartScale * (d / pinchStartDist), mid.x, mid.y, false);
        return;
      }

      if (scale > 1 && panFrom) {
        tx = panFrom.tx + (event.clientX - panFrom.x);
        ty = panFrom.ty + (event.clientY - panFrom.y);
        clampPan();
        applyTransform(false);
      }
    });

    function endPointer(event) {
      if (!pointers.has(event.pointerId)) return;
      pointers.delete(event.pointerId);

      // Zbyly dva prsty ze tří: přebazuj pinch na ně. Bez toho by se vzdálenost
      // měřila mezi jiným párem prstů, než na jaký byl naměřený pinchStartDist.
      if (pointers.size >= 2) {
        const p = pointerList();
        pinchStartDist = distance(p[0], p[1]);
        pinchStartScale = scale;
        return;
      }

      // Zbyl jeden prst: přebazuj posun i gesto na něj. Bez toho by se počítalo
      // z pozice prstu, který už na displeji není, a fotka by uskočila.
      if (pointers.size === 1) {
        const rest = pointerList()[0];
        pinchStartDist = 0;
        panFrom = { x: rest.x, y: rest.y, tx: tx, ty: ty };
        gestureStart = { x: rest.x, y: rest.y };
        return;
      }
      if (pointers.size > 0) return;

      const start = gestureStart;
      const wasMulti = multiTouch;
      gestureStart = null;
      panFrom = null;
      pinchStartDist = 0;
      multiTouch = false;
      if (!start) return;

      const dx = event.clientX - start.x;
      const dy = event.clientY - start.y;
      const moved = Math.hypot(dx, dy);

      // Po pinchi se tap ani swipe nevyhodnocuje — dráha mezi prvním dotykem
      // a posledním zvednutým prstem s gestem nijak nesouvisí.
      if (wasMulti) { suppressClick = true; return; }

      if (moved < 10) {
        // Klik po gestu polykáme vždy; zavření řeší rovnou gesto, protože
        // klikový handler už neuvidí ani stage, ani box.
        suppressClick = true;
        if (!downOnPhoto) { closeBox(); return; }
        const now = performance.now();
        if (now - lastTapAt < 300) {
          zoomAt(scale > 1 ? 1 : TAP_SCALE, event.clientX, event.clientY, true);
          lastTapAt = 0;
        } else {
          lastTapAt = now;
        }
        return;
      }

      suppressClick = true;

      if (scale === 1) {
        if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
        else if (dy > 90 && Math.abs(dx) < 60) closeBox();
      }
    }

    stage.addEventListener('pointerup', endPointer);
    stage.addEventListener('pointercancel', endPointer);

    stage.addEventListener('wheel', function (event) {
      event.preventDefault();
      zoomAt(scale * (event.deltaY < 0 ? 1.15 : 1 / 1.15), event.clientX, event.clientY, false);
    }, { passive: false });

    const hintEl = box.querySelector('[data-mediabox-hint]');
    let hintTimer = 0;

    function maybeHint() {
      if (!hintEl) return;
      if (fine.matches) return;
      try {
        if (sessionStorage.getItem('hagane:zoom-hint')) return;
        sessionStorage.setItem('hagane:zoom-hint', '1');
      } catch (err) {
        // Privátní režim může sessionStorage zakázat — hint se pak ukáže pokaždé.
      }
      hintEl.hidden = false;
      clearTimeout(hintTimer);
      hintTimer = setTimeout(function () { hintEl.hidden = true; }, 2500);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    // Spare gallery images ship with no src, so nothing here can be bypassed by the
  // browser's own lazy loading. Two stages, so a 24-card grid never pays for slides
  // nobody looked at:
  //   1. IntersectionObserver, after window.load -> slide 2 of each nearby card, so
  //      the first swipe (or the first hover) is instant. One extra image per card.
  //   2. first scroll of a given track           -> the remaining slides of THAT card.
  // On a pointer device slides 3+ are display:none, so they have no box, the observer
  // never fires for them and stage 2 never runs — a desktop visitor still downloads
  // exactly one extra image per card, as before the carousel existed.
  (function () {
    function load(img) {
      if (img.dataset.src) { img.srcset = img.dataset.srcset || ''; img.src = img.dataset.src; }
      delete img.dataset.src;
      delete img.dataset.srcset;
    }

    function loadTrack(track) {
      track.querySelectorAll('[data-card-alt][data-src]').forEach(load);
    }

    function loadNext(track) {
      var next = track.querySelector('[data-card-alt][data-src]');
      if (next) load(next);
    }

    function arm() {
      var tracks = document.querySelectorAll('[data-card-track]');
      if (!tracks.length) return;

      // Observe the TRACK, not the images. On touch the slides past the first are
      // clipped by the scroll port, and an observer reports a clipped element as not
      // intersecting however large the rootMargin — so watching the images directly
      // loaded nothing on a phone and the first swipe landed on a placeholder.
      // The track always has a box, on both pointer types.
      if (!('IntersectionObserver' in window)) {
        tracks.forEach(loadNext);
      } else {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            loadNext(e.target);
            io.unobserve(e.target);
          });
        }, { rootMargin: '200px' });
        tracks.forEach(function (t) { io.observe(t); });
      }

      tracks.forEach(function (track) {
        if (track.dataset.carouselBound) return;
        track.dataset.carouselBound = '1';

        // .card, not track.parentElement: the dots sit outside .card__media so the
        // absolutely-positioned quick-add chip stays anchored to the photo.
        var card = track.closest('.card');
        var dots = card ? card.querySelector('[data-card-dots]') : null;
        var slides = track.children;
        var pending = false;

        function sync() {
          pending = false;
          if (!dots || !slides.length) return;
          // Round rather than floor: mid-swipe the nearest slide is the honest answer.
          var i = Math.round(track.scrollLeft / track.clientWidth);
          if (i < 0) i = 0;
          if (i > dots.children.length - 1) i = dots.children.length - 1;
          for (var d = 0; d < dots.children.length; d++) {
            dots.children[d].classList.toggle('is-on', d === i);
          }
        }

        track.addEventListener('scroll', function () {
          // The rest of this card's slides, once — the visitor has shown intent.
          loadTrack(track);
          if (pending) return;
          pending = true;
          requestAnimationFrame(sync);
        }, { passive: true });
      });
    }

    if (document.readyState === 'complete') arm();
    else window.addEventListener('load', arm, { once: true });
    // Sections re-rendered by the theme editor bring their own un-armed images.
    document.addEventListener('shopify:section:load', arm);
  })();

  // Delegated once for every product card on the page. Adds the single variant
  // and lets the global cart modal (listening for `cart:add`) confirm it.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-card-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.classList.contains('is-added')) return;
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id) return;
    btn.classList.add('is-added');
    document.dispatchEvent(new CustomEvent('cart:add', { detail: { items: [{ id: id, quantity: 1 }] } }));
    setTimeout(function () { btn.classList.remove('is-added'); }, 1600);
  });
  } catch(e) { console.error(e); }
})();

})();
